import { Center, Text } from "@chakra-ui/react";

export default function SongcardDescription() {
  return (
    <>
      <Center>
        <Text fontSize="xl" maxW={"sm"} mb={10} mt={0} textAlign={"center"}>
          Songcards are a new format for digital music.
          <br />
          <br />
          Think of them as <b>deluxe edition singles.</b> <br />
          <br />
          They{`’`}re a way for artists to turn a song into a unique digital
          experience. <br />
          <br />
          Not only do they unlock MP3 and WAV downloads of the song, but
          collectors can access all manner of exclusive material offered by the
          songcard.
          <br />
          <br />
          Some artists have included items such as lyric sheets, desktop
          wallpapers, and behind-the-scenes footage.
          <br />
          <br />
          When you buy a songcard, it gets delivered to your inbox directly.
          From there you{`'`}ll be able to access all of its features.
          <br /> <br />
          Songcards is a new format for digital music, aiming at providing fans
          a way to unlock experiences offered by their favourite musicians.
        </Text>
      </Center>
    </>
  );
}
